<template>
  <div id="app">
    <v-app id="inspire">
      <div>
        <v-toolbar flat color="white">
          <v-toolbar-title>Empresas</v-toolbar-title>
          <v-divider
            class="mx-2"
            inset
            vertical
          ></v-divider>
          <v-spacer></v-spacer>
          <v-combobox
            v-if="esconder"
            v-model="search"
            placeholder="Pesquise"
            hide-no-data
            hide-selected
            append-icon="search"
            @change="getPesquisa"
          ></v-combobox>
          <v-spacer></v-spacer>
          <v-btn v-if="esconder" color="primary" dark class="mb-2" @click="create()">Novo</v-btn>
        </v-toolbar>
      </div>
      <v-data-table
        v-if="esconder"
        :headers="headers"
        :items="rows"
        class="elevation-1"
        :loading="loading"
        hide-actions
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.nome_fantasia }}</td>
          <td class="text-xs-left">{{ props.item.cnpj }}</td>
          <td class="text-xs-left">{{ props.item.razao_social }}</td>
          <td class="text-xs-left">{{ props.item.inscricao_estadual }}</td>
          <td class="text-xs-left">{{ props.item.endereco }}</td>
          <td class="text-xs-left">{{ props.item.criacao }}</td>
          <td class="justify-center layout px-0">
            <v-icon
              small
              class="mr-2"
              @click="editItem(props.item)"
            >
              edit
            </v-icon>
            <v-icon
              small
              @click="deleteItem(props.item)"
            >
              delete
            </v-icon>
          </td>
        </template>
      </v-data-table>
      <div class="text-xs-center pa-3">
        <div class="text-center pa-2">
          <v-progress-circular
            v-if="mostrar"
            :indeterminate="indeterminate"
            :size="200"
            :width="3"
            color="light-blue"
          >Espere terminar de carregar...</v-progress-circular>
        </div>
         <paginate
            v-if="esconder"
            :page-count="total"
            :page-range="10"
            :page-link-class="'texto'"
            :margin-pages="2"
            :click-handler="getData"
            :prev-text="'Anterior'"
            :next-text="'Próxima'"
            :container-class="'pagination'"
            :page-class="'page-item'"
            :active-class="'ativa'">
          </paginate>
      </div>
    </v-app>
  </div>
</template>


<script>
  import {sharedService} from '../services'

  export default {
    name: 'Empresas',
    data() {
      return {
        rows: [],
        total: 0,
        loading: false,
        headers: [
        {
            text: 'Nome',
            align: 'left',
            value: 'nome_fantasia'
        },
        {text: 'CNPJ', value: 'cnpj'},
        {text: 'Razão Social', value: 'razao_social'},
        {text: 'Inscrição estadual', value: 'inscricao_estadual'},
        {text: 'Endereço', value: 'endereco'},
        {text: 'Data de Criação', value: 'criacao'}
        ],
        text: '',
        search: '',
        filtros: '',
        indeterminate: false,
        esconder: false,
        mostrar: false
      }
    },
    methods: {
      getTotal: async function(){
        let self = this
        this.mostrar = true
        this.indeterminate = true
        this.esconder = false
         if(!this.filtros){
          await sharedService.read('Empresas').then(function (obj){
            let totalItens = obj.total_records/10
            if(Number.isInteger(totalItens) === true){
              self.total =parseInt(totalItens)
              self.mostrar = false
              self.indeterminate = false
              self.esconder = true
            } else {
              self.total = parseInt(totalItens.toFixed(1)) + 1
              self.mostrar = false
              self.indeterminate = false
              self.esconder = true
            }
          })
        } else if(this.filtros){
            await sharedService.read('Empresas?'+this.filtros).then(function (obj){
            let totalItens = obj.total_records/10
            if(Number.isInteger(totalItens) === true){
              self.total =parseInt(totalItens)
              self.mostrar = false
              self.indeterminate = false
              self.esconder = true
            } else {
              self.total = parseInt(totalItens.toFixed(1)) + 1
              self.mostrar = false
              self.indeterminate = false
              self.esconder = true
            }
          })
        } 
      },
      getPesquisa: async function(){
        let self = this
        this.loading = true
        if(self.search){
          self.filtros = 'search='+self.search
          self.getTotal()
          self.getData()
        } else {
          self.filtros = ''
          self.getTotal()
          self.getData()
        }
        this.loading = false
      },
      getData: async function (pageNum) {
        let self = this
        this.loading = true
        if(!this.filtros){
          if(pageNum === undefined){
            await sharedService.read('Empresas?limit=10&page=1').then(function (obj){
              self.rows = obj.obj
              self.loading = false
            })
          } else {
            await sharedService.read('Empresas?limit=10&page='+pageNum).then(function (obj){
              self.rows = obj.obj
              self.loading = false
            })
          }
        } else if(this.filtros){
          if(pageNum === undefined || pageNum === '0'){
            await sharedService.read('Empresas?limit=10&page=1&'+this.filtros).then(function (obj){
              self.rows = obj.obj
              self.loading = false
            })
          } else {
            await sharedService.read('Empresas?limit=10&page='+pageNum+'&'+this.filtros).then(function (obj){
              self.rows = obj.obj
              self.loading = false
            })
          }
        }
      },
      create() {
        this.$router.push({
          name: 'EmpresasForm'
        })
      },
      editItem (item) {
        this.$router.push({
          name: 'EmpresaEdit',
          params: {id: item.id}
        })
      },
      async deleteItem (item){
        let self = this
        this.$confirm('Tem certeza que deseja deletar este item?').then(res => {
          if (res) {
            sharedService._delete('Empresas',item.id).then(function (obj){
              obj.text().then(function (text){
                  if(obj.status === 200){
                      self.$store.dispatch('success', 'Empresa excluída com sucesso!')
                  }  else {
                      self.$store.dispatch('error', text)
                  }
              })
              self.getTotal()
              self.getData()
            })
          } else {
            this.close()
          }
        })
      }
    },
    beforeMount() {
      this.getTotal()
      this.getData()
    }
  }
</script>

<style>
  .pagination {
    list-style-type: none;
  }
  .page-item {
    border: solid 1px #eeeeee ;
    background: #f5f5f5;
    font-size:15px;
    padding:13px 16px;
    display: inline-block;
  }
  .ativa{
    background: #bdbdbd   ;
    border: solid 1px #bdbdbd  ;
  }

  .texto{
    color: #424242 ;
  }
  
</style>